import { useRouter } from "next/router";
import { Link, Box } from "@chakra-ui/react";
import { GetCookie } from "../provider/common";
import axios from "axios";
import { useCallback } from "react";
import styles from "../styles/components/searchFigma/ResultListItem.module.css";

const Goto = ({ pics, data, isLoginCheck, keyword }) => {
  const router = useRouter();

  const CombineBotAsked = useCallback(async () => {
    if (isLoginCheck === "1") {
      try {
        const body = [
          {
            it_id: data.it_id,
            it_brand: data.manufacturer,
            it_name: data.pn,
            it_maker: data.source,
            // 재고를 다 넘기는게 아니라 무조건 1개만 추가
            qty: 1,
          },
        ];

        const result = await axios.post(
          `${process.env.PANDA_API_URL}/api/mall/insertQuoteLists`,
          body,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${await GetCookie("token")}`,
            },
          },
        );

        if (result.data.status === 200) {
          if (
            window.confirm(
              "견적바구니에 저장되었습니다. 견적바구니로 이동하시겠습니까?",
            )
          ) {
            router.push(`/marketplace/cart`);
          }
        } else {
          alert("견적바구니에 저장이 실패하였습니다.");
        }
      } catch (error) {
        console.error("⛔ CombineBotAsked Error:", error);
        alert("견적바구니에 저장이 실패하였습니다.");
      }
    } else {
      const href = `/auth/login?before=/search/lists?keyword=${encodeURIComponent(
        keyword,
      )}`;
      router.push(href);
    }
  }, [isLoginCheck, data, pics, keyword, router]);

  // 견적바로받기 버튼
  const renderInquiryButton = () => (
    <div onClick={CombineBotAsked} className={styles.buttonGroup}>
      <div className={styles.requestButton}>
        <div className={styles.iconLightning}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M20.0484 11.7619L9.54838 23.0119C9.43711 23.1306 9.29023 23.21 9.12992 23.2379C8.9696 23.2659 8.80455 23.2409 8.65966 23.1668C8.51476 23.0928 8.3979 22.9736 8.3267 22.8272C8.2555 22.6809 8.23382 22.5154 8.26494 22.3556L9.63932 15.481L4.23651 13.4522C4.12047 13.4088 4.017 13.3373 3.93533 13.2442C3.85366 13.151 3.79633 13.0391 3.76847 12.9184C3.74062 12.7977 3.7431 12.6719 3.77569 12.5524C3.80828 12.4329 3.86998 12.3233 3.95526 12.2335L14.4553 0.983457C14.5665 0.86471 14.7134 0.785374 14.8737 0.757423C15.034 0.729473 15.1991 0.754423 15.344 0.828509C15.4889 0.902595 15.6057 1.0218 15.6769 1.16813C15.7481 1.31446 15.7698 1.47998 15.7387 1.63971L14.3606 8.52189L19.7634 10.5478C19.8786 10.5915 19.9812 10.6629 20.0622 10.7557C20.1433 10.8485 20.2002 10.9598 20.228 11.0798C20.2558 11.1998 20.2536 11.3248 20.2216 11.4438C20.1897 11.5628 20.1289 11.672 20.0446 11.7619H20.0484Z"
              fill="white"
            />
          </svg>
        </div>
        <div className={`${styles.bodyiconLigthing} body3`}>견적바로받기</div>
      </div>
      <div className={styles.iconChevronRight}>
        {" "}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M5.29289 3.29289C5.68342 2.90237 6.31643 2.90237 6.70696 3.29289L10.707 7.29289C10.8945 7.48043 10.9999 7.73471 10.9999 7.99992C10.9999 8.26514 10.8945 8.51942 10.707 8.70696L6.70696 12.707C6.31643 13.0975 5.68342 13.0975 5.29289 12.707C4.90237 12.3164 4.90237 11.6834 5.29289 11.2929L8.58586 7.99992L5.29289 4.70696C4.90237 4.31643 4.90237 3.68342 5.29289 3.29289Z"
            fill="white"
          />
        </svg>
      </div>
    </div>
  );
  // 구매하기 버튼
  const renderBuyButton = (href) => (
    <a href={href}>
      <div className={styles.buttonGroupBuy}>
        <div className={styles.requestButton}>
          <div className={`${styles.buyiconBlack} body3`}>구매하기</div>
        </div>

        <div className={styles.iconChevronRight}>
          {" "}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M5.29289 3.29289C5.68342 2.90237 6.31643 2.90237 6.70696 3.29289L10.707 7.29289C10.8945 7.48043 10.9999 7.73471 10.9999 7.99992C10.9999 8.26514 10.8945 8.51942 10.707 8.70696L6.70696 12.707C6.31643 13.0975 5.68342 13.0975 5.29289 12.707C4.90237 12.3164 4.90237 11.6834 5.29289 11.2929L8.58586 7.99992L5.29289 4.70696C4.90237 4.31643 4.90237 3.68342 5.29289 3.29289Z"
              fill="#2F2F2F"
            />
          </svg>
        </div>
      </div>
    </a>
  );
  // arrow 에 L7805CDT-TR 에 MOQ 가 1인 경우 예외 처리
  if (
    pics.source === "arrow" &&
    data.pn === "L7805CDT-TR" &&
    Number(pics.moq) === 1
  ) {
    return renderInquiryButton();
  }

  if (pics.source === "partner") return renderInquiryButton();

  if (pics.source === "pandaparts" && Number(pics.item_price) === 0)
    return renderInquiryButton();

  if (pics.source === "pandaparts" && Number(pics.price) === 0)
    return renderInquiryButton();

  // 판다파츠 1인 경우 버튼 예외 처리
  if (pics.source === "pandaparts" && Number(pics.item_price) === 1)
    return renderInquiryButton();

  if (pics.source === "pandaparts" && Number(pics.price) === 1)
    return renderInquiryButton();

  if (
    pics.source === "pandaparts" &&
    pics.item_price !== undefined &&
    pics.item_price !== 0
  )
    return renderBuyButton(`/parts/mallview/${pics.it_id}`);

  if (Number(pics.stock) === 0 || Number(pics.price) === 0)
    return renderInquiryButton();

  if (pics.source === "pandaparts")
    return renderBuyButton(`/parts/view/ON${pics.stock_no}`);

  if (data.manufacturer?.toLowerCase().includes("analog device"))
    return renderInquiryButton();

  return renderBuyButton(`/parts/view/PD${pics.stock_no}`);
};

export default Goto;
